const pastevents = [
  {
    pastEventName: "Kirtans - Biweekly",
    caption:
      "Our club hosts biweekly kirtans on campus, creating a welcoming space for students to connect through music, devotion, and spirituality. These gatherings aim to nurture inner peace and support mental well-being in a positive community setting.",
    image1: "/sss_images/past_events/Kirtan1.jpg",
    image2: "/sss_images/past_events/Kirtan2.jpg",
    image3: "/sss_images/past_events/Kirtan3.jpg",
    image4: "/sss_images/past_events/Kirtan4.png",
  },
  {
    pastEventName: "Ganesh Chaturthi - September 2024",
    caption:
      "We celebrated Ganesh Chaturthi as our club’s very first event, marking an auspicious beginning filled with devotion and joy. The celebration brought students together to honor Lord Ganesha and seek his blessings for wisdom, prosperity, and new beginnings.",
    image1: "/sss_images/past_events/GaneshChaturthi1.JPG",
    image2: "/sss_images/past_events/GaneshChaturthi2.png",
    image3: "/sss_images/past_events/GaneshChaturthi3.jpg",
    image4: "/sss_images/past_events/GaneshChaturthi4.JPG",
  },
  {
    pastEventName: "Navratri & Mahalaya - October 2024",
    caption:
      "Our club celebrated Navratri and Mahalaya by honoring both the vibrant cultural traditions of Navratri and the spiritual significance of Mahalaya, which marks the beginning of Devi Paksha and the arrival of Goddess Durga. The event showcased diverse practices of Navratri, while also including Garba to bring students together in devotion, celebration, and cultural unity.",
    image1: "/sss_images/past_events/Navratri1.png",
    image2: "/sss_images/past_events/Navratri2.png",
    image3: "/sss_images/past_events/Navratri3.JPG",
    image4: "/sss_images/past_events/Navratri4.png",
  },
  {
    pastEventName: "Diwali & Kali Puja - November 2024",
    caption:
      "We celebrated Diwali and Kali Puja to honor the victory of light over darkness and the triumph of good over evil, while also invoking the strength and protection of Goddess Kali. By observing these festivals, we aimed to share their deep spiritual and cultural significance, fostering unity, positivity, and cultural appreciation among students on campus.",
    image1: "/sss_images/past_events/Diwali1.jpg",
    image2: "/sss_images/past_events/Diwali2.jpg",
    image3: "/sss_images/past_events/Diwali3.jpg",
    image4: "/sss_images/past_events/Diwali4.jpg",
  },
  {
    pastEventName: "Mandir Trip #1 - January 2025",
    caption:
      "We started the new year by visiting the mandir together as a club, seeking blessings and beginning the year on a spiritual note. The trip gave our members a chance to reflect, bond, and ground themselves in positivity.",
    image1: "/sss_images/past_events/MandirTripOne1.png",
    image2: "/sss_images/past_events/MandirTripOne2.png",
  },
  {
    pastEventName: "Table Booking - January 2025",
    caption:
      "Our club set up a table in Mac Hall to connect with students and share our mission. It was a wonderful opportunity to introduce our events and welcome new members into our community.",
    image1: "/sss_images/past_events/TableBooking1.jpg",
    image2: "/sss_images/past_events/TableBooking2.jpg",
    image3: "/sss_images/past_events/TableBooking3.jpg",
    image4: "/sss_images/past_events/TableBooking4.jpg",
  },
  {
    pastEventName: "Career Session - January 2025",
    caption:
      "We hosted an insightful career session focused on resume tips, networking strategies, and career development. The event aimed to provide student support and empower members to confidently shape their professional journeys.",
    image1: "/sss_images/past_events/CareerSession1.jpg",
    image2: "/sss_images/past_events/CareerSession2.jpg",
    image3: "/sss_images/past_events/CareerSession3.jpg",
    image4: "/sss_images/past_events/CareerSession4.jpg",
  },
  {
    pastEventName: "Saraswati Puja - February 2025",
    caption:
      "Our club made history as the first to celebrate Saraswati Puja at the University of Calgary. Students gathered to honor the Goddess of knowledge, art, wisdom, and learning, seeking inspiration for their academic journeys.",
    image1: "/sss_images/past_events/SaraswatiPooja1.jpg",
    image2: "/sss_images/past_events/SaraswatiPooja2.JPG",
    image3: "/sss_images/past_events/SaraswatiPooja3.JPG",
    image4: "/sss_images/past_events/SaraswatiPooja4.JPG",
  },
  {
    pastEventName: "Maha Shivratri - February 2025",
    caption:
      "We celebrated Maha Shivratri to honor Lord Shiva, the embodiment of meditation and transformation. The event reminded students of the importance of inner strength and spiritual growth.",
    image1: "/sss_images/past_events/ShivRatri1.png",
    image2: "/sss_images/past_events/ShivRatri2.jpg",
    image3: "/sss_images/past_events/ShivRatri3.jpg",
    image4: "/sss_images/past_events/ShivRatri4.jpg",
  },
  {
    pastEventName: "Holi - March 2025",
    caption:
      "We celebrated Holi, the festival of colors, with joy, laughter, and togetherness. The vibrant event symbolized love, unity, and the triumph of good over evil.",
    image1: "/sss_images/past_events/Holi1.jpg",
    image2: "/sss_images/past_events/Holi2.png",
    image3: "/sss_images/past_events/Holi3.png",
    image4: "/sss_images/past_events/Holi4.jpg",
  },
  {
    pastEventName: "Bake Sale - April 2025",
    caption:
      "Our club hosted a bake sale in the Earth Science Lobby to raise funds and share homemade treats with the campus community. It was a fun way to spread sweetness while supporting our initiatives.",
    image1: "/sss_images/past_events/BakeSale1.jpg",
    image2: "/sss_images/past_events/BakeSale2.jpg",
    image3: "/sss_images/past_events/BakeSale3.jpg",
    image4: "/sss_images/past_events/BakeSale4.jpg",
  },
  {
    pastEventName: "Ram Navami - April 2025",
    caption:
      "We proudly became the first club to celebrate Ram Navami at the University of Calgary, honoring the birth of Lord Rama. The event highlighted values of righteousness, courage, and devotion.",
    image1: "/sss_images/past_events/RamNavami1.jpg",
    image2: "/sss_images/past_events/RamNavami2.jpg",
    image3: "/sss_images/past_events/RamNavami3.jpg",
    image4: "/sss_images/past_events/RamNavami4.jpg",
  },
  {
    pastEventName: "Janmashtami - August 2025",
    caption:
      "As the first club that celebrated Janmashtami on campus, we joyfully honored the birth of Lord Krishna. The celebration brought music, devotion, and unity to our student community.",
    image1: "/sss_images/past_events/Janmashtami1.jpg",
    image2: "/sss_images/past_events/Janmashtami2.jpg",
    image3: "/sss_images/past_events/Janmashtami3.jpg",
    image4: "/sss_images/past_events/Janmashtami4.jpg",
  },
  {
    pastEventName: "Mandir Trip #2 - August 2025",
    caption:
      "We celebrated our official registration under the Students’ Union (SU) with a visit to ISKCON Calgary. The trip was filled with gratitude, devotion, and excitement for the journey ahead.",
    image1: "/sss_images/past_events/TempleVisitTwo1.jpg",
    image2: "/sss_images/past_events/TempleVisitTwo2.png",
  },
  {
    pastEventName: "Kirtan by Peace Bridge - August 2025",
    caption:
      "To mark our official SU registration, we hosted an uplifting Kirtan by the Peace Bridge. The event spread joy, spirituality, and positivity in the heart of Calgary.",
    image1: "/sss_images/past_events/PeaceBridge1.jpg",
    image2: "/sss_images/past_events/PeaceBridge2.jpg",
    image3: "/sss_images/past_events/PeaceBridge3.jpg",
    image4: "/sss_images/past_events/PeaceBridge4.jpg",
  },
  {
    pastEventName: "Ganesh Chaturthi - September 2025",
    caption:
      "We celebrated Ganesh Chaturthi with devotion and joy, honoring Lord Ganesha and seeking his blessings. We also celebrated our 1st anniversary of the club, along with our club registration and initial launch of our official website.",
    image1: "/sss_images/past_events/GaneshChaturthi2025_1.png",
    image2: "/sss_images/past_events/GaneshChaturthi2025_2.png",
    image3: "/sss_images/past_events/GaneshChaturthi2025_3.png",
    image4: "/sss_images/past_events/GaneshChaturthi2025_4.png",
  },
  {
    pastEventName: "Navratri & Durga Puja - October 2025",
    caption:
      "We celebrated Navratri and Durga Puja with devotion, music, and cultural performances. The event honored Goddess Durga and we wrapped it up by doing Garba.",
    image1: "/sss_images/past_events/NavratriDurgaPuja2025_1.png",
    image2: "/sss_images/past_events/NavratriDurgaPuja2025_2.png",
    image3: "/sss_images/past_events/NavratriDurgaPuja2025_3.png",
    image4: "/sss_images/past_events/NavratriDurgaPuja2025_4.png",
  },
  {
    pastEventName: "Diwali and Kali Puja - November 2025",
    caption:
      "We celebrated Diwali, the festival of lights, with devotion, music, and cultural performances. The event honored goddess Kali, and focussed on the triumph of good over evil.",
    image1: "/sss_images/past_events/Diwali2025_1.png",
    image2: "/sss_images/past_events/Diwali2025_2.png",
    image3: "/sss_images/past_events/Diwali2025_3.png",
    image4: "/sss_images/past_events/Diwali2025_4.png",
  },
  {
    pastEventName: "Saraswati Puja - January 2026",
    caption:
      "We celebrated Saraswati Puja with devotion, music, and cultural performances. The event honored goddess Saraswati, and focussed on the triumph of knowledge.",
    image1: "/sss_images/past_events/SaraswatiPuja2026_1.png",
    image2: "/sss_images/past_events/SaraswatiPuja2026_2.png",
    image3: "/sss_images/past_events/SaraswatiPuja2026_3.png",
    image4: "/sss_images/past_events/SaraswatiPuja2026_4.png",
  },
  {
    pastEventName: "Maha Shivratri - February 2026",
    caption:
      "We celebrated Maha Shivratri with devotion, music, and cultural performances honoring lord Shiva.",
    image1: "/sss_images/past_events/MahaShivratri2026_1.png",
    image2: "/sss_images/past_events/MahaShivratri2026_2.png",
    image3: "/sss_images/past_events/MahaShivratri2026_3.png",
    image4: "/sss_images/past_events/MahaShivratri2026_4.png",
  },
  {
    pastEventName: "Holi - March 2026",
    caption:
      "We celebrated Holi, the festival of colors, with joy, laughter, and togetherness. The vibrant event symbolized love, and unity.",
    image1: "/sss_images/past_events/Holi2026_1.png",
    image2: "/sss_images/past_events/Holi2026_2.png",
    image3: "/sss_images/past_events/Holi2026_3.png",
    image4: "/sss_images/past_events/Holi2026_4.png",
  },
  {
    pastEventName: "Ram Navami - April 2026",
    caption:
      "We celebrated Ram Navami with devotion, music, and cultural performances honoring Lord Rama.",
    image1: "/sss_images/past_events/RamNavami2026_1.png",
    image2: "/sss_images/past_events/RamNavami2026_2.png",
    image3: "/sss_images/past_events/RamNavami2026_3.png",
    image4: "/sss_images/past_events/RamNavami2026_4.png",
  },
  {
    pastEventName: "Janmashtami - August 2026",
    caption:
      "We celebrated Janmashtami, the birth of Lord Krishna, with devotion, music, and cultural performances.",
    image1: "/sss_images/past_events/Janmashtami2026_1.png",
    image2: "/sss_images/past_events/Janmashtami2026_2.png",
    image3: "/sss_images/past_events/Janmashtami2026_3.png",
    image4: "/sss_images/past_events/Janmashtami2026_4.png",
  },
];

export default pastevents;
